import Isotope from 'isotope-layout';
import './_carousel.js';
import './_img-slider.js';

const $grid = document.querySelector('.section-5 .theme-wrap');
const initShow = 6;
const refreshLayout = () => {iso.layout()}; 
let counter = initShow;

//Isotope
const iso = new Isotope($grid, {
  itemSelector: '.cardWrap',
  layoutMode: 'fitRows',
  transitionDuration: '0s',
  percentPosition: true
})

//Add Load More Btn
$grid.insertAdjacentHTML('afterend','<button id="load-more" class="btn btn-large btn-shadow white text-blue-grey text-darken-3 margin-top-m margin-bottom-s">Load More</button>');

// Show the first 6
iso.filteredItems.slice(initShow, iso.filteredItems.length).map(item => {
  item.element.hidden = true
});
refreshLayout();

// Load more themes
function loadMore(toShow) {
  iso.filteredItems.slice(0, toShow).map(item => {
    item.element.hidden = false
  });
  refreshLayout();
  hideLoadMoreButton();
}

// Hide button when there are no more themes 
function hideLoadMoreButton(){
  if(counter >= iso.items.length){
    loadMoreBtn.classList.remove('active');
  }
 
}
document.addEventListener('DOMContentLoaded', () => {
  window.loadMoreBtn = document.getElementById('load-more');
  loadMoreBtn.classList.add('active');
  loadMoreBtn.addEventListener('click',(e)=>{
    loadMore(counter+=3)
  })
})
